// Configure pdf.js worker for react-pdf
import { pdfjs } from 'react-pdf';

// Use local worker from node_modules (version 5.x uses .mjs extension)
if (typeof window !== 'undefined') {
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
  ).toString();
}

// Import global styles
import './index.css';

// Declare global constants injected by Vite define
declare const AUTH0_DOMAIN: string;
declare const AUTH0_CLIENT_ID: string;
declare const AUTH0_AUDIENCE: string;
declare const API_BASE_URL: string;
declare const ENVIRONMENT: string;

import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { RoleProvider } from "./contexts/role-context";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

const domain = AUTH0_DOMAIN;
const clientId = AUTH0_CLIENT_ID;
const audience = AUTH0_AUDIENCE;
const apiBaseUrl = API_BASE_URL;
const environment = ENVIRONMENT;

// Debug information - remove in production
// console.log("Environment:", environment);
// console.log("Auth0 Domain:", domain);
console.log("Auth0 Client ID:", clientId);
// console.log("Auth0 Audience:", audience);
// console.log("API Base URL:", apiBaseUrl);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin + "/auth/callback",
        audience: audience,
        scope: "openid profile email",
      }}
      // cacheLocation="localstorage" // Helps with persistence after page refresh
    >
      <RoleProvider><App /></RoleProvider>
      
    </Auth0Provider>
  </React.StrictMode>
);
